<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.add_foobar')"></section-intro>
    <foobar-add></foobar-add>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import FoobarAdd from '@/components/foobar/FoobarAdd'
  import SectionIntro from '@/components/partials/SectionIntroPattern'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      FoobarAdd,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// AddFoobar.vue?09e6aa16